import { useEffect, useState, useCallback } from 'react';

export default function useEditMode() {
  const [editMode, setEditMode] = useState(false);
  const inIframe = typeof window !== 'undefined' && window.parent !== window;

  useEffect(() => {
    if (!inIframe) return;
    const handler = e => {
      if (e.data?.type === 'AMKO_EDIT_MODE') setEditMode(true);
      if (e.data?.type === 'AMKO_SCROLL_TO') {
        const el = document.getElementById(e.data.section)
          || document.querySelector(`[id="${e.data.section}"], .${e.data.section}-section`);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    window.addEventListener('message', handler);
    try { window.parent.postMessage({ type: 'AMKO_READY' }, '*'); } catch {}
    return () => window.removeEventListener('message', handler);
  }, [inIframe]);

  const notifySection = useCallback((section, data) => {
    if (!inIframe) return;
    try { window.parent.postMessage({ type: 'AMKO_SECTION_UPDATE', section, data }, '*'); } catch {}
  }, [inIframe]);

  return { editMode, notifySection };
}
